import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Transition } from "../../pages/app/utils/animation";
import { Warning } from "@mui/icons-material";
import { useModals } from "../../store/dialogs/hooks.js";

export const GlimpseModelLengthDialog = ({
  frameSizeHi,
  minLength,
  handleQueueGlimpse,
}) => {
  const { showGlimpseModelLengthDialog, closeGlimpseModelLengthDialog } =
    useModals();

  return (
    <Dialog
      aria-labelledby="glimpse-model-length-dialog"
      aria-describedby="glimpse-model-length-dialog-description"
      aria-hidden={!showGlimpseModelLengthDialog}
      closeAfterTransition={false}
      onClose={() => closeGlimpseModelLengthDialog()}
      open={showGlimpseModelLengthDialog}
      maxWidth="xs"
      slots={{
        transition: Transition,
      }}
      keepMounted
    >
      <DialogTitle
        id="glimpse-model-length-dialog-title"
        display="flex"
        alignItems="center"
        gap={0.5}
      >
        <Warning color="warning" fontSize="medium" />
        Warning
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText
          sx={{ mb: 1 }}
          id="glimpse-model-length-dialog-description"
        >
          The selected Frame Size High <strong>({frameSizeHi} samples)</strong>{" "}
          is longer than the length of the model{" "}
          <strong>({minLength} samples)</strong>. This may result in
          unpredictable results when refocusing.
        </DialogContentText>
        <DialogContentText>
          Click continue to proceed with the selected focusing aperture or
          cancel to select a different focusing aperture.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => closeGlimpseModelLengthDialog()}
        >
          cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            closeGlimpseModelLengthDialog();
            handleQueueGlimpse();
          }}
          autoFocus
        >
          continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
